
import Vue from 'vue'
import PriceLabel from '@/components/PriceLabel.vue'
import { SVG_PLACEHOLDER_IMAGES } from '@/constants'
import { similarProductsQuery } from '@/pages/product/queries'
import { apolloClient } from '@/service/apolloClient'
import { SYSTEM_ERROR } from '@/utils/const'
import { getSimilarProducts_similarProducts_items as ProductType } from '@/pages/product/types/getSimilarProducts'
import BaseImage from '@/components/BaseImage.vue'
// import PrintTag from '@/components/PrintTag.vue'

export default Vue.extend({
  components: {
    PriceLabel,
    BaseImage
    // PrintTag
  },
  data(): {
    productList: Array<ProductType>,
    itemOffset: number,
    itemLimit: number,
    itemTotalCount: number,
    itemPage: number,
    slideClass: string
  } {
    return {
      productList: [],
      itemOffset: 4,
      itemLimit: 4,
      itemTotalCount: 0,
      itemPage: 1,
      slideClass: 'slide-out'
    }
  },
  computed: {
    disablePrev(): boolean {
      return this.itemPage == 1
    },
    disableNext(): boolean {
      return this.itemPage == this.itemTotalPage
    },
    productId(): string{
      return this.$route.params.id
    },
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    itemTotalPage(): number{
      return this.itemTotalCount < this.itemLimit ? 1 : Math.ceil(this.itemTotalCount / this.itemLimit)
    }
  },
  created() {
    this.returnSimilarProducts()
  },
  methods: {
    loadMoreProduct(pageIndex: number, itemClass: string){
      if (pageIndex >= 1 && pageIndex <= this.itemTotalPage){
        this.itemPage = pageIndex
        this.slideClass = itemClass
        this.returnSimilarProducts()
      }
    },
    async returnSimilarProducts() {
      this.itemOffset = 0
      if (this.itemPage != 1) {
        this.itemOffset = (this.itemPage * this.itemLimit) - this.itemLimit
      }
      await apolloClient
        .query({
          query: similarProductsQuery,
          variables: {
            id: this.productId,
            offset: this.itemOffset,
            limit: this.itemLimit
          }
        })
        .then(response => {
          this.productList = response.data?.similarProducts.items
          this.itemTotalCount = response.data?.similarProducts.totalItemsCount
        })
        .catch(error => {
          if (error?.response?.status) {
             alert(error || SYSTEM_ERROR.UNKNOWN)
          }
        })
    },
    similarProductPagePath(similarProductId: string): string {
      return `/products/${similarProductId}`
    }
  }
})
